import BaseService from '@/services/base.service';
import store from '../store'

const API_URL = process.env.VUE_APP_API_URL;
// const CURRENCY_CODE = process.env.VUE_APP_CURRENCY_CODE;
// const ACCOUNT_SLUG = process.env.VUE_APP_ACCOUNT_SLUG;

class RetailService extends BaseService {
    apiGetRetailMarkets(games) {
        return this.post(API_URL + '/api/v2/retail/markets', {
            account: store.state.account,
            currency: store.state.currencyCode,
            marketType: "main",
            games: games
        }).then((response) => {
            const status = response.data.status;
            if (status === 'success') {
                return response.data.results;
            }
            return response.data;
        }).catch(err => {
            throw err.response.data;
        })
    }

    retailBetslipMarkets(bets) {
        return this.post(API_URL + '/api/v2/retail/betslip', {
            account: store.state.account,
            currency: store.state.currencyCode,
            bets: bets
        }).then((response) => {
            const status = response.data.status;
            if (status === 'success') {
                return response.data;
            }
            return response.data;
        }).catch(err => {
            throw err.response.data;
        })
    }
}

export default new RetailService();
